import React from "react";
import { Link } from "react-scroll";
import { scrollDuration } from "../../../config/commonConfig";
import {
  HeroBottomTitle,
  HeroCta,
  HeroTagline,
  ProfileImage,
} from "../../shared/IntroHeroContent";

const BottomHeaderDefaultIntro = () => {
  return (
    <section
      id="home"
      className="bg-primary d-flex flex-column fullscreen py-5 position-relative"
    >
      <div className="container my-auto">
        <div className="row">
          <div className="col-lg-10 mx-auto text-center">
            <ProfileImage wrapperClassName="bg-white shadow rounded-pill p-4 mb-6 d-inline-block wow zoomIn" />
            <HeroBottomTitle />
            <HeroTagline className="text-5 pb-3 wow fadeInUp" />
            <HeroCta className="btn btn-dark rounded-0 smooth-scroll wow fadeInUp" />
          </div>
        </div>
      </div>
      <div className="container py-2 text-center">
        <Link
          className="scroll-down-arrow text-dark smooth-scroll"
          smooth="easeInOutQuint"
          duration={scrollDuration}
          style={{ cursor: "pointer" }}
          to="about"
        >
          <span className="animated">
            <i className="fas fa-arrow-down" />
          </span>
        </Link>
      </div>
    </section>
  );
};

export default BottomHeaderDefaultIntro;
